import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#fffefc]" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <HowItWorks data-id="element-3" />
      <Testimonials data-id="element-4" />
      <FAQ data-id="element-5" />
      <Footer data-id="element-6" />
    </div>;
}